import Templates from "../../../components/templates/templates";
import Page from "../../page";

const TemplatesPage = () => {
  return (
    <Page>
      <Templates />
    </Page>
  );
};

export default TemplatesPage;
